// Footer.js
import React from 'react';
// import './Footer.css'; // Import the corresponding CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Hema Priya. All rights reserved.</p>
        <div className="footer-links">
          <a href="mailto:hemapriya2000mdu@gmail.com">Gmail</a>
          <a href="https://linkedin.com/in/hema-priya-b-777484154" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="https://github.com/hemapriyavk" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
